var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C14.6115 30 14.2389 29.8457 13.9642 29.571C13.6895 29.2962 13.5352 28.9237 13.5352 28.5352V1.46484C13.5352 1.07634 13.6895 0.703754 13.9642 0.429043C14.2389 0.154331 14.6115 0 15 0C15.3885 0 15.7611 0.154331 16.0358 0.429043C16.3105 0.703754 16.4648 1.07634 16.4648 1.46484V28.5352C16.4648 28.9237 16.3105 29.2962 16.0358 29.571C15.7611 29.8457 15.3885 30 15 30Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5352 16.4648H1.46484C1.07634 16.4648 0.703754 16.3105 0.429043 16.0358C0.154331 15.7611 0 15.3885 0 15C0 14.6115 0.154331 14.2389 0.429043 13.9642C0.703754 13.6895 1.07634 13.5352 1.46484 13.5352H28.5352C28.9237 13.5352 29.2962 13.6895 29.571 13.9642C29.8457 14.2389 30 14.6115 30 15C30 15.3885 29.8457 15.7611 29.571 16.0358C29.2962 16.3105 28.9237 16.4648 28.5352 16.4648Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.1098bd5b935ce6f263d67ff99827ec02.svg";
export { ForwardRef as ReactComponent };